<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="q-pa-md">
    <q-stepper
      v-if="activeGroupOrder"
      v-model="step"
      color="primary"
      class=""
      flat
      alternative-labels
    >
      <q-step
        :name="1"
        title="Now"
        :caption="formatDate(new Date())"
        icon="where_to_vote"
      />

      <q-step
        :name="2"
        title="Container Closes"
        :caption="`${formatDate(activeGroupOrder.closeDate)} (${fromNow(activeGroupOrder.closeDate)})`"
        icon="gavel"
      />

      <q-step
        :name="3"
        title="Manufacturing"
        :caption="`~${monthsToManufacture} months`"
        icon="build"
      />

      <q-step
        :name="4"
        title="Shipping"
        :caption="`~${monthsToShip} months`"
        icon="directions_boat"
      />

      <q-step
        :name="5"
        title="Delivered"
        :caption="`Estimated ${formatMonth(deliveryDateEstimate)}`"
        icon="cake"
      />

      <template v-slot:navigation>
      </template>
    </q-stepper>

    <q-stepper
      v-else
      v-model="step"
      color="primary"
      class=""
      flat
      alternative-labels
    >
      <q-step
        :name="1"
        title="No Currently Open Container"
        icon="access_time"
        color="primary"
      />
      <template v-slot:navigation>
      </template>
    </q-stepper>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { formatDateTime, formatDate, formatMonth, fromNow } from '../util/string'
import moment from 'moment'

export default {
  name: 'ContainerTimeline',
  apollo: {
    activeGroupOrder () {
      return {
        query: gql`
          query {
            activeGroupOrder {
              id
              name
              openDate
              closeDate
            }
          }
        `
      }
    }
  },
  computed: {
    deliveryDateEstimate () {
      return moment(this.activeGroupOrder.closeDate)
        .add(this.monthsToManufacture + this.monthsToShip, 'M') // The 'M' is for months, eg. 5 months.
    }
  },
  methods: {
    formatDateTime,
    formatDate,
    formatMonth,
    fromNow
  },
  data () {
    return {
      monthsToManufacture: 3,
      monthsToShip: 2,
      step: 0
    }
  }
}
</script>

<style scoped>

</style>
